import CountUp from "react-countup";
import { Col, Container, Row } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { CountersTitle } from "../../../Constants/Constants";
import { CountersData, CountersSettingsData } from "../../../Data/Bonus/About";

const Counters = () => {
  return (
    <section className="counter-sec section-py-space counter-main">
      <Container>
        <div className="counter-title">
          <h4 className="title-line">{CountersTitle}</h4>
        </div>
        <Row>
          <Col xs="12">
            <div className="counter-slider pt-0">
              <Swiper {...CountersSettingsData} className="mySwiper">
                {CountersData.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="position-relative">
                      <div className="counter-icon">
                        <i className={`fa fa-${item.icon}-o`} />
                      </div>
                      <div className="counter-icon-1">
                        <i className={`fa fa-${item.icon}-o`} />
                      </div>
                      <div className="counter-box-second">
                        <div className="counter-box">
                          <div>
                            <CountUp end={item.endValue} className="counter-no count" delay={1} />
                            <span>{item.title}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Counters;
